import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal, Navbar } from 'react-bootstrap';
import axios from 'axios'

import { AdminNav, RequestModal, Loading } from '../../helpers';
import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function';
import { similarity } from '../../helpers/functionForJob';
import { onPrint } from '../../helpers/functionForLicense';
import { exportExcelDaily, renderRequestPDF } from '../../helpers/functionForRequest';
import jsPDF from 'jspdf'
import font from '../../helpers/THSarabun-normal'
class RequestDaily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseID: '',
      history: [],
      arr: [],
      toggle: 'collapse multi-collapse',
      isLoading: true,
      riceDescriptionArr: {},
      approve: '',
      arrData: {},
      currentIndex: 0,
      finalIndex: 99,
      pairColor: {},
      riceTypeIDAndName: {},
      networkStatus: null,
      dupColor: {}
    }
    this.handleCollaspe = this.handleCollaspe.bind(this)
    this.handleApprove = this.handleApprove.bind(this)
    this.handleApprove2 = this.handleApprove2.bind(this)
    this.handleApproveChain = this.handleApproveChain.bind(this)
    this.handleApproveAll = this.handleApproveAll.bind(this)
    this.handlePressEnter = this.handlePressEnter.bind(this)
    this.handleInputStartJobID = this.handleInputStartJobID.bind(this)
    this.renderCompany = this.renderCompany.bind(this)
  }
  sameName(godownName) {
    if (godownName == 'ชวิน เอ็กซ์ปอร์ต-นครสวรรค์' || godownName == 'เค. วี. ซี. ไร้ซ์ อินเตอร์เทรด-นครสวรรค์' || godownName == 'นครสวรรค์โรงสีไฟไทยรุ่งเรือง (2002)-นครสวรรค์') {
      return 'ชวิน เอ็กซ์ปอร์ต-นครสวรรค์'
    }
    else if (godownName == 'โตมี ฟูดส์ แอนด์โปรดักส์-ปทุมธานี' || godownName == 'โตมีอินเตอร์เทรด-ปทุมธานี' || godownName == 'โมสต์ อินเตอร์เนชั่นแนล-ปทุมธานี' || godownName == 'โตมีฟูดส์แอนด์โปรดักส์-ปทุมธานี') {
      return 'โตมี ฟูดส์ แอนด์โปรดักส์-ปทุมธานี'
    }
    else if (godownName == 'เต็กรุ่งเรืองพาณิชย์-สุพรรณบุรี' || godownName == 'แฟนซีไรซ์-สุพรรณบุรี') {
      return 'เต็กรุ่งเรืองพาณิชย์-สุพรรณบุรี'
    }
    else if (godownName == 'ดับบลิว แอนด์ พี เอ็กซ์ปอร์ต-พระนครศรีอยุธยา' || godownName == 'ชัยประสิทธิ์พืชผล-พระนครศรีอยุธยา' || godownName == 'วิริยะโรจน์-อยุธยา') {
      return 'ดับบลิว แอนด์ พี เอ็กซ์ปอร์ต-พระนครศรีอยุธยา'
    }
    else if (godownName == 'ข้าวสิริมงคล-นครราชสีมา' || godownName == 'นครราชสีมา ศิริโชคชัย-นครราชสีมา') {
      return 'ข้าวสิริมงคล-นครราชสีมา'
    }
    else if (godownName == 'ที.เค. ไรซ์มิลล์ แอนด์ แอช-นครปฐม' || godownName == 'ธัญญกิจ นครปฐม (2521)-นครปฐม') {
      return 'ที.เค. ไรซ์มิลล์ แอนด์ แอช-นครปฐม'
    }
    else if (godownName == 'พิมานโกลเด้นไรซ์-กรุงเทพฯ' || godownName == 'พิมานวรกิจ (1999)-กรุงเทพฯ') {
      return 'พิมานโกลเด้นไรซ์-กรุงเทพฯ'
    }
    else if (godownName == 'สยามโกลเด้นไรซ์-สระบุรี' || godownName == 'โชคฉัตรไชยไรซ์มิล-สระบุรี') {
      return 'สยามโกลเด้นไรซ์-สระบุรี'
    }
    else if (godownName == 'กรุงไทยพืชผล-สมุทรปราการ' || godownName == 'ไชยพรไรซแอนด์ฟู้ดโปรดักส์-สมุทรปราการ') {
      return 'กรุงไทยพืชผล-สมุทรปราการ'
    }
    else if (godownName == 'ข้าวบัวทิพย์ มาร์เก็ตติ้ง-ขอนแก่น' || godownName == 'เค.ซี. โกลเด้นไร้ซ์-ขอนแก่น') {
      return 'ข้าวบัวทิพย์ มาร์เก็ตติ้ง-ขอนแก่น'
    }
    else if (godownName == 'วิงออนไรซ์ เทรดดิ้ง-ปทุมธานี' || godownName == 'ที.ที.เอส. ไรซ์-ปทุมธานี') {
      return 'วิงออนไรซ์ เทรดดิ้ง-ปทุมธานี'
    }
    else if (godownName == 'เพิ่มลาภ-สิงห์บุรี' || godownName == 'รวมใจเจริญทรัพย์-สิงห์บุรี') {
      return 'รวมใจเจริญทรัพย์-สิงห์บุรี'
    }
    else if (godownName == 'ธนกรบรรจงสรร-พิจิตร' || godownName == 'ทีบีเอส ไรซ์มิลล์-พิจิตร') {
      return 'ธนกรบรรจงสรร-พิจิตร'
    }
    else if (godownName == 'ธัญญไรซ์ (ไทยแลนด์)-สมุทรปราการ' || godownName == 'สเปเชียล ไรซ์-สมุทรปราการ') {
      return 'ธัญญไรซ์ (ไทยแลนด์)-สมุทรปราการ'
    }
    else if (godownName == 'วัจนสุรัตน์-ฉะเชิงเทรา' || godownName == 'วิวัฒนาพืชผล-ฉะเชิงเทรา') {
      return 'วัจนสุรัตน์-ฉะเชิงเทรา'
    }
    else if (godownName == 'สุชินการเกษตร-สุพรรณบุรี' || godownName == 'โปรเกรสซีเรียล-สุพรรณบุรี') {
      return 'สุชินการเกษตร-สุพรรณบุรี'
    }
    else {
      return godownName
    }
  }

  componentDidMount() {
    let start = new Date()
    let startRequest = new Date()
    let startReqeustJob = new Date()
    let startViewOfficer = new Date()
    let startViewCompany = new Date()

    let startViewRiceType = new Date()

    let RequestComplete = fetch(`https://backend1.riceinspections.com/testA?timeValue=${this.props.location.state.timeValue}`).then((res) => {
      console.log('timeA', new Date() - startRequest)
      return res.json()
    })
    let RequestJobComplete = fetch('https://backend1.riceinspections.com/testB').then((res) => {
      console.log('timeB', new Date() - startReqeustJob)
      return res.json()
    })

    let viewAllOfficer = fetch('https://backend1.riceinspections.com/testC').then((res) => {
      console.log('timeC', new Date() - startViewOfficer)
      return res.json()
    })

    let viewAllCompany = fetch('https://backend1.riceinspections.com/testD').then((res) => {
      console.log('timeD', new Date() - startViewCompany)
      return res.json()
    })
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      console.log('timeE', new Date() - startViewRiceType)
      return res.json()
    })

    Promise.all([RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany, viewAllRiceTypeIDAndNamePromise])
      .then((res) => {
        // console.log(new Date() - start)

        RequestComplete = res[0] || {}
        RequestJobComplete = res[1] || {}
        viewAllOfficer = res[2] || {}
        viewAllCompany = res[3] || {}
        viewAllRiceTypeIDAndNamePromise = res[4] || {}
        let dataForUpdate = this.updateState(RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany)
        let newArr = dataForUpdate['0']
        let newRiceDescriptionArr = dataForUpdate['1']
        let pairColor = dataForUpdate['2']
        viewAllOfficer = Object.values(viewAllOfficer).sort((a,b) => parseInt(a.userName) - parseInt(b.userName))
        this.setState({
          ...this.state,
          RequestComplete: RequestComplete,
          RequestJobComplete: RequestJobComplete,
          viewAllOfficer: viewAllOfficer,
          arr: newArr,
          isLoading: false,
          riceDescriptionArr: newRiceDescriptionArr,
          viewAllCompany: viewAllCompany,
          pairColor: pairColor,
          riceTypeIDAndName: viewAllRiceTypeIDAndNamePromise
        })
      }).catch((err) => {
        console.log(err)
        this.setState({
          ...this.state,
          networkStatus: 'การเชื่อมต่ออินเทอร์เน็ตมีปัญหา'
        })
      })

  }
  updateState = (RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany) => {
    let arr = []
    // console.log(!RequestJobComplete['message'])
    Object.keys(RequestComplete).map((title) => {
      if (title !== 'countJobID') {
        if (typeof RequestComplete[title] == 'object' && !RequestJobComplete['message']) {
          if (!RequestComplete['message']) {
            // console.log(!RequestComplete['message'])
            let temp = Object.values(RequestJobComplete).filter((e) => { return e['requestID'] == RequestComplete[title]['requestID'] })
            if (temp.length != 0) {
              RequestComplete[title]['jobID'] = temp[0]['jobID']
              if (temp[0]['chainID'] == 'chain') {
                RequestComplete[title]['chainID'] = 'ต่อ'
              }
              if (temp[0]['chainID'] == 'extraround') {
                RequestComplete[title]['chainID'] = 'นอกรอบ'
              }
              if (temp[0]['chainID'] == 'sampling') {
                RequestComplete[title]['chainID'] = 'เก็บตัวอย่าง'
              }
              if (temp[0]['chainID'] == 'controlloading') {
                RequestComplete[title]['chainID'] = 'คุมขนถ่าย'
              }
              if (temp[0]['chainID'] == 'cancleloading') {
                RequestComplete[title]['chainID'] = 'งดบรรทุก'
              }
              if (temp[0]['chainID'] == 'extrajob') {
                RequestComplete[title]['chainID'] = 'งานพิเศษ'
              }
              if (temp[0]['chainID'] == 'blank') {
                RequestComplete[title]['chainID'] = 'blank'
              }

              RequestComplete[title]['officerID'] = temp[0]['officerID']
              RequestComplete[title]['officerID2'] = temp[0]['officerID2']
              arr = arr.concat([RequestComplete[title]])
            } else {
              RequestComplete[title]['officerID'] = ''
              RequestComplete[title]['officerID2'] = ''
              arr = arr.concat([RequestComplete[title]])
            }
          }
        }
      }
    })
    // console.log(arr)
    Object.values(viewAllOfficer).map((Checker) => {
      let id = Checker['ID']
      arr.forEach((data) => {
        if (data['officerID'] == id) {
          data['officerID'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']}`
        }
        if (data['officerID2'] == id) {
          data['officerID2'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']} `
        }
        if (data['officerID2'] == '') {
          data['officerID2'] = `-`
        }
      })
    })
    Object.values(viewAllCompany).map((Company) => {
      let id = Company['companyID']
      arr.forEach((data) => {
        // console.log(data['companyID'])
        if (data['companyID'] == id) {
          data['companyID'] = `${Company['companyNameEN']}`
        }
      })
    })
    let surveyName = []
    let riceDescriptionArr = {}
    arr.sort((a, b) => (parseInt(a['jobID']) > parseInt(b['jobID'])) ? 1 : ((parseInt(b['jobID']) > parseInt(a['jobID'])) ? -1 : 0))
    arr.forEach((data, idx) => {
      // console.log(data)
      if (data['chainID'] !== 'none') {
        let temp = arr.filter((e) => { return e['requestID'] == data['chainID'] })
        if (temp.length != 0) {
          data['chainID'] = `/ ต่อ Job NO:${temp[0]['jobID']}`
        }
      } else {
        data['chainID'] = ``
      }

      // console.log(data)
      if (data['description']) {

        Object.values(data['description']).sort((a, b) => {
          if (a) {
            if (b) {
              // console.log(a['riceTypeID'] > b['riceTypeID'])
              if (a['riceTypeID'] < b['riceTypeID']) {
                return -1
              }
              if (a['riceTypeID'] > b['riceTypeID']) {
                return 1
              }
              else {
                return 0
              }
            }
          }
        })
        if (data['surveyLocateName'].indexOf('ลาดกระบัง') == -1 && data['surveyLocateName'].indexOf('ท่าเรือคลองเตย') == -1) {
          let godownName = this.sameName(`${data['surveyLocateName']}-${data['surveyProvince']}`)
          surveyName.push(this.hashCode(godownName))
          // surveyName.push(data['surveyLocateName'])
        } else {
          surveyName.push(this.hashCode(`${idx}`))
          // console.log('skip as 1')
        }
        // console.log(data)
        Object.values(data['description']).map((dataDescription) => {
          // console.log(dataDescription)
          if (dataDescription != null && typeof dataDescription == 'object') {
            // console.log(data,idx)
            riceDescriptionArr = {
              ...riceDescriptionArr,
              [idx]: {
                ...riceDescriptionArr[idx],
              }
            }
            riceDescriptionArr = {
              ...riceDescriptionArr,
              [idx]: {
                ...riceDescriptionArr[idx],
                [dataDescription['riceTypeID']]: (() => {
                  if (riceDescriptionArr[idx]) {
                    if (!riceDescriptionArr[idx][dataDescription['riceTypeID']]) {
                      return (Math.round(parseFloat(dataDescription['quantity']) * 1000) / 1000).toFixed(4)
                    } else {
                      return (parseFloat(dataDescription['quantity']) + parseFloat(riceDescriptionArr[idx][dataDescription['riceTypeID']])).toFixed(4)
                    }
                  }
                })(),
                [`Total${dataDescription['riceTypeID']}`]: (() => {
                  if (riceDescriptionArr[idx]) {
                    if (!riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`]) {
                      return 1
                    } else {
                      return 1 + (riceDescriptionArr[idx][`Total${dataDescription['riceTypeID']}`])
                    }
                  }
                })()
              }
            }
          }
        })
      }
    })
    var colors = ['#FFAACC', '#FFCCCC', '#FFFFCC', '#CCAAFF',
      '#CCDDFF', '#CCFFEE', '#CCDDDD', '#CCFFCC', 'fuchsia', 'lime', 'red', 'maroon'];
    // console.log(surveyName)
    let pairLocation = this.findDup(surveyName)
    let depColorSet = {}

    Object.values(pairLocation).map((ignoreData, idx) => {
      ignoreData.map((data) => {
        depColorSet = {
          ...depColorSet,
          [data]: colors[idx]
        }
      })
    })
    // console.log(depColorSet)
    return { '0': arr, '1': riceDescriptionArr, '2': depColorSet }
  }
  hashCode(s) {
    return s.split("").reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0);
  }
  findDup(arr) {
    var duplicates = {}
    for (var i = 0; i < arr.length; i++) {
      if (duplicates.hasOwnProperty(arr[i])) {
        duplicates[arr[i]].push(i);
      } else if (arr.lastIndexOf(arr[i]) !== i) {
        duplicates[arr[i]] = [i];
      }
    }
    return duplicates;
  }

  sendData = (d, idx, idz, objNested) => {
    // console.log(idx,idz)
    // console.log(d)
    let alpha = this.state.arr[idx]?.['jobID']
    if (parseInt(alpha) > 0) {
      let a = ''
      // console.log(d[idx]['officerID'])
      if (d[idx]?.['officerID']) {
        a = d[idx]['officerID']
      }
      let b = this.state.arr[idx]['requestID']
      let c = ''
      if (d[idx]?.['chainID']) {
        c = d[idx]['chainID']
      }
      let e = ''
      if (d[idx]?.['officerID2']) {
        e = d[idx]['officerID2']
      }
      console.log(`jobID = ${alpha} , officerID = ${a} , requestID = ${b}, chainID = ${c} , officerID2 = ${e} `)
      objNested.push({
        jobID: alpha,
        officerID: a,
        requestID: b,
        chainID: c,
        officerID2: e,
      })
      if (idx != parseInt(idz) - 1) {
        let newIdx = idx + 1
        this.setState({ ...this.state, currentIndex: newIdx })
        this.sendData(d, newIdx, idz, objNested)
      } else {
        console.log(objNested)
        axios.post(
          'https://backend1.riceinspections.com/testFAA',
          {
            data: [...objNested]
          }
        ).then((res)=>{
          this.setState({ ...this.state, currentIndex: [...objNested].length },()=>{
            setTimeout(()=>{
              window.location.reload()
            },1000)
          })
        }).catch((err) => {
          alert('ไม่สามารถเชื่อมต่อกับ Server ได้')
          window.location.reload()
        })
        // window.location.reload()
      }

    } else {
      this.setState({
        ...this.state,
        isLoading: true
      })
      window.location.reload()
    }
  }
  handleApproveAll = () => {
    let arrData = this.state.arrData
    let objNested = []
    let idz = Object.values(arrData).length
    let idx = 0

    this.sendData(arrData, idx, Object.values(this.state.arr).length, objNested)
    this.setState({...this.state,isLoading : true, currentIndex : idx ,finalIndex:idz})  
  }
  handleApprove = (e, requestID, idx) => {
    this.setState({
      ...this.state,
      arrData: {
        ...this.state.arrData,
        [idx]: {
          ...this.state.arrData[idx],
          requestID: requestID,
          officerID: e.target.value,
        }
      }
    }, () => { console.log(this.state.arrData) })
  }
  handleApprove2 = (e, requestID, idx) => {
    // console.log(e.target.value)
    this.setState({
      ...this.state,
      arrData: {
        ...this.state.arrData,
        [idx]: {
          ...this.state.arrData[idx],
          requestID: requestID,
          officerID2: e.target.value,
        }
      }
    })


  }
  handleApproveChain = (e, requestID, idx) => {
    console.log(e.target.value, idx)
    this.state.arrData[idx] = {
      ...this.state.arrData[idx],
      'chainID': e.target.value
    }
    this.setState({
      ...this.state,
      arrData: {
        ...this.state.arrData,
        [idx]: {
          ...this.state.arrData[idx],
          'requestID': requestID,
          'chainID': e.target.value,
        }
      }
    }, () => { console.log(this.state.arrData) })
  }

  handleCollaspe = (idz, riceType) => {
    let elems = document.getElementsByName(`hiddenRow${idz}${riceType}`)
    elems.forEach((el) => {
      if (el.getAttribute("class") == 'collapse multi-collapse') {
        el.className = 'collapse multi-collapse show'
        this.setState({
          ...this.state,
          toggle: 'collapse multi-collapse show',
        })
      } else {
        el.className = 'collapse multi-collapse'
        this.setState({
          ...this.state,
          toggle: 'collapse multi-collapse',
        })
      }
    })
  }
  // el.attributes['class'] = 'collapse multi-collapse show'
  // handleCancle = (idx)=>{
  //   let elem = document.getElementById(idx)
  //   elem.style.backgroundColor = '#ff7f7f'
  // }
  renderCollaps(data) {
    if (parseInt(data) > 1) {
      return <a href="javascript:void(0)">รวม {data} รายการ</a>
    } else {
      return `รวม ${data} รายการ`
    }
  }
  renderLicenseID(data, idx) {
    return <a href="javascript:void(0)" onClick={() => { onPrint(data['description'][idx]['licenseID']) }}> {data['description'][idx]['licenseID'].slice(6, data['description'][idx]['licenseID'].length)}</a>
  }
  renderQuantity(data, idx) {
    if (data['description'][idx]['quantity']) {
      return data['description'][idx]['quantity']
    } else if (data['description'][idx]['Quantity']) {
      return data['description'][idx]['Quantity']
    } else {
      return null
    }
  }
  renderColor(data) {
    if (data['chainID'] == 'ต่อ') {
      return '#90ee90'
    } else if (data['chainID'] == 'นอกรอบ') {
      return '#b7e9f7'
    } else {
      if (data['officerID'] == 'cancel') {
        return '#ff7f7f'
      } else {
        return 'white'
      }
    }
  }
  handlePressEnter(e) {
    console.log(e.key)
    if (e.key == 'Enter') {
      // console.log(e.key)
      let a = []
      let b = null
      let startJobID = this.state.startJobID
      Object.values(this.state.arr).map((data) => {
        b = {
          ...data,
          jobID: startJobID
        }
        a.push(b)
        startJobID = this.incrementString(startJobID)
      })

      this.setState({
        ...this.state,
        arr: a
      })
    }
  }
  incrementString(str) {
    var text = str;
    var getPart = text.replace(/[^\d.]/g, ''); // returns 0023
    var num = parseInt(getPart); // returns 23
    var newVal = num + 1; // returns 24
    var reg = new RegExp(num); // create dynamic regexp
    var newstring = text.replace(reg, newVal); // returns MPG_0024
    return newstring
  }

  handleInputStartJobID(e) {
    console.log(e.target.value)
    this.setState({
      ...this.state,
      startJobID: e.target.value
    })
  }
  handleInputJobID(e) {
    console.log(e.target.value, e.target.id)
    let arr = this.state.arr
    arr[e.target.id]['jobID'] = e.target.value
    this.setState({
      ...this.state,
      arr: arr
    })
  }
  goToEdit(idx) {
    // console.log(this.state.arr)
    this.props.history.push({
      pathname: '/RequestEdit',
      state: {
        ...this.state.arr[idx],
        timeShow: this.props.location.state.timeShow || new Date(),
        timeValue: this.props.location.state.timeValue || new Date()
      }
    })
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  renderCompany(companyObj) {
    // console.log(this.state.viewAllCompany)
    let viewAllCompany = this.state.viewAllCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }
  render() {
    if (!this.state.isLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Navbar style={{ backgroundColor: '#F5F5F5', zIndex: '0' }} sticky="top" >
            <Container style={{ zIndex: '0' }} >
              <Navbar.Brand> <Button variant="success" onClick={() => { exportExcelDaily(this.state.arr) }}> Download Excel </Button></Navbar.Brand>
              <p><b>บันทึกการรับแจ้งและจ่ายงานการตรวจข้าว ประจำวันที่ {this.renderDate(this.props.location.state.timeValue || new Date())}</b></p>
              <Navbar.Brand><Button variant="success" onClick={() => { this.handleApproveAll() }}> ยืนยันทั้งหมด </Button></Navbar.Brand>
            </Container>
          </Navbar>
          {/* {console.log(this.props.location.state.timeValue || new Date() )} */}
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
          </div>
          <Table bordered hover style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ width: '1.7%', overflow: 'auto', fontSize: '11px' }}>ลำดับที่</th>
                <th style={{ width: '5.2%', overflow: 'auto', fontSize: '11px' }}>คำสั่งจ่ายงาน</th>
                <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อบริษัทส่งออก</th>
                <th style={{ width: '6.7%', overflow: 'auto', fontSize: '11px' }}>สถานที่ตรวจบรรทุก</th>
                <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>เวลาบรรทุก</th>
                <th style={{ width: '6.7%', overflow: 'auto', fontSize: '11px' }}>พนักงานตรวจข้าว / ต่อ</th>
                <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>ต่อ</th>
                <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อพาหนะ</th>
                <th style={{ width: '6.7%', overflow: 'auto', fontSize: '11px' }}>ประเทศปลายทาง</th>
                <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>เลขที่ใบอนุญาต</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '10px' }}>รายการที่</th>
                <th style={{ width: '6.2%', overflow: 'auto', fontSize: '11px' }}>ชนิดข้าว</th>
                <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>ปริมาณ / ตัน</th>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              <tr>
                <td></td>
                <td><input style={{ width: '100%', fontSize: '13px' }} onChange={this.handleInputStartJobID} onKeyDown={this.handlePressEnter}></input></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {this.state.arr.map((data, idz) => {
                if (typeof data == 'object') {
                  if (data['description']) {
                    let riceTypeDuplicated = []
                    return (Object.keys(data['description']).map((idx, indexTable) => {
                      if (data['description'][idx]) {
                        if (riceTypeDuplicated.indexOf(data['description'][idx]['riceTypeID']) == -1) {
                          if (indexTable == 0) {
                            riceTypeDuplicated.push(data['description'][idx]['riceTypeID'])
                            return (<tr id={idz}>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }}><b>{parseInt(idz) + 1}</b></td>
                              <td style={{ width: '2.7%', fontSize: '13px' }}><input id={idz} style={{ width: '100%' }} onChange={(e) => { this.handleInputJobID(e) }} value={data['jobID']}></input> <br></br> <a href="javascript:void(0)" onClick={() => { this.goToEdit(idz) }}>Edit </a></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '100%', overflow: 'auto', fontSize: '13px' }}><b >{data['companyEN'] || this.renderCompany(data['companyID'])}</b><br /> <a href="javascript:void(0)" onClick={() => { renderRequestPDF(data, new jsPDF('p', 'mm', [840.51, 595.40]), font, convertRiceTypeENToTH, this.state.riceTypeIDAndName) }}>PDF </a></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', overflow: 'auto', height: '100%', fontSize: '13px' }}> <mark style={{ backgroundColor: this.state.pairColor[idz] || 'white' }}><b>{data['surveyLocateName']} - {data['surveyProvince']}</b></mark></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }}><b>{data['shippingTime']} น.</b></td>
                              <td style={{ width: '4.7%', fontSize: '13px' }}>
                                <select style={{ width: '100%', backgroundColor: this.renderColor(data) }} onChange={(e) => { this.handleApprove(e, data['requestID'], idz) }}>

                                  <option value="" selected disabled hidden>{data['officerID'].slice(0, data['officerID'].indexOf('นาย') != -1 ? data['officerID'].indexOf('นาย') : 0)}{data['officerID'].slice(parseInt(data['officerID'].indexOf('นาย') != -1 ? data['officerID'].indexOf('นาย') : -3) + 3, data['officerID'].length)}</option>
                                  <option value=""></option>
                                  <option value="cancel">ยกเลิก</option>
                                  {Object.keys(this.state.viewAllOfficer).map((res) => {
                                    // console.log(this.state.arrData[idz]?.['officerID'],data['officerID'])
                                    if (data['officerID']) {
                                      this.state.arrData[idz] = {
                                        ...this.state.arrData[idz],
                                        'requestID': data['requestID'],
                                        'officerID': this.state.arrData[idz]?.['officerID'] || data['officerID'],
                                      }
                                      // console.log( data['officerID'],data['requestID'],idz)
                                    }
                                    let c = this.state.viewAllOfficer[res]
                                    if(c.userName != '9999'){
                                      return (
                                        <option value={c['ID']}>{parseInt(c.userName) + 1} {c.fName.slice(3, c.fName.length)}</option>
                                      )
  
                                    }
                                  })}
                                </select>
                                <br />
                                <select style={{ width: '100%', backgroundColor: this.renderColor(data) }} onChange={(e) => { this.handleApprove2(e, data['requestID'], idz) }}>
                                  <option value="" selected disabled hidden>{data['officerID2']}</option>
                                  <option value=""></option>
                                  <option value="cancel">ยกเลิก</option>
                                  {Object.keys(this.state.viewAllOfficer).map((res) => {
                                    // console.log(this.state.viewAllOfficer[res])
                                    let c = this.state.viewAllOfficer[res]
                                    // console.log(c)
                                    if(c.userName != '9999'){
                                      return (
                                        <option value={c['ID']}>{parseInt(c.userName) + 1} {c.fName.slice(3, c.fName.length)}</option>
                                      )  
                                    }
                                  })}
                                </select>
                              </td>
                              <td style={{ width: '7.7%', fontSize: '13px' }}>
                                <select style={{ width: '100%', backgroundColor: this.renderColor(data) }} onChange={(e) => { this.handleApproveChain(e, data['requestID'], idz) }} value={this.state.arrData[`${idz}`]?.chainID}>
                                  {(() => {
                                    if (data['chainID'] != 'blank') {
                                      console.log(data['chainID'],idz,data['godown'])
                                      return <option value="" selected disabled hidden>{data['chainID']}</option>
                                    } else {
                                      return <option value="" selected disabled hidden></option>
                                    }
                                  })()}
                                  {(() => {
                                    if (this.state.pairColor[idz] && data['chainID'] == undefined && this.state.arrData[`${idz}`]?.chainID == undefined && this.state.dupColor[this.state.pairColor[idz]] == undefined) {
                                      // console.log('chagne')
                                      this.state.dupColor[this.state.pairColor[idz]] = idz
                                    }
                                    else if (this.state.pairColor[idz] && data['chainID'] == undefined && this.state.arrData[`${idz}`]?.chainID == undefined) {
                                      // console.log('aprove',this.state.dupColor[this.state.pairColor[idz]])
                                      if (this.state.dupColor[this.state.pairColor[idz]] != idz) {
                                        this.handleApproveChain({ 'target': { 'value': 'chain' } }, data['requestID'], idz)
                                      }
                                    }
                                  })()}
                                  <option value="blank"></option>
                                  <option value={"cancel"}>ยกเลิก</option>
                                  <option value={'chain'}>ต่อ</option>
                                  <option value={'extraround'}>นอกรอบ</option>
                                  <option value={'sampling'}>เก็บตัวอย่าง</option>
                                  <option value={'controlloading'}>คุมขนถ่าย</option>
                                  <option value={'cancleloading'}>งดบรรทุก</option>
                                  <option value={'extrajob'}>งานพิเศษ</option>
                                </select>
                              </td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['vehicleName'] || data['description'][idx][`vehicleName${idx}`]} </b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['destinationCity']}</b></td>
                              <td style={{ overflow: 'auto', fontSize: '13px' }}>{this.renderLicenseID(data, idx)}</td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', fontSize: '13px' }}><b>{parseInt(data['description'][idx]['subID']) + 1}</b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['riceTypeName'] || convertRiceTypeENToTH(data['description'][idx]['riceTypeID'], this.state.riceTypeIDAndName, 'standalone')}</b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }} style={{ width: '7.7%', fontSize: '13px' }}><b>{addCommaInNumber(this.state.riceDescriptionArr[idz][data['description'][idx]['riceTypeID']])}</b> <br /> {this.renderCollaps(this.state.riceDescriptionArr[idz][`Total${data['description'][idx]['riceTypeID']}`])}</td>
                            </tr>)
                          } else {
                            riceTypeDuplicated.push(data['description'][idx]['riceTypeID'])
                            return (<tr id={idz} >
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }}></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', fontSize: '13px' }}></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', fontSize: '13px' }}><div style={{ width: '30%' }}></div></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', fontSize: '13px' }}></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }}></td>
                              <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                              <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['vehicleName'] || data['description'][idx][`vehicleName${idx}`]} </b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['destinationCity']}</b></td>
                              <td style={{ overflow: 'auto', fontSize: '13px' }}>{this.renderLicenseID(data, idx)}</td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '4.7%', fontSize: '13px' }}><b>{parseInt(data['description'][idx]['subID']) + 1}</b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '2.7%', fontSize: '13px' }}><b>{data['description'][idx]['riceTypeName'] || convertRiceTypeENToTH(data['description'][idx]['riceTypeID'], this.state.riceTypeIDAndName, 'standalone')}</b></td>
                              <td onClick={() => { this.handleCollaspe(idz, data['description'][idx]['riceTypeID']) }} style={{ width: '7.7%', fontSize: '13px' }} style={{ width: '7.7%', fontSize: '13px' }}><b>{addCommaInNumber(this.state.riceDescriptionArr[idz][data['description'][idx]['riceTypeID']])}</b> <br /> {this.renderCollaps(this.state.riceDescriptionArr[idz][`Total${data['description'][idx]['riceTypeID']}`])}</td>
                            </tr>)
                          }
                        } else {
                          return (<tr className={`collapse multi-collapse`} name={`hiddenRow${idz}${data['description'][idx]['riceTypeID']}`} >
                            <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '2.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '2.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '2.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                            <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                            <td style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}></td>
                            <td style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}>{data['description'][idx]['destinationCity']}</td>
                            <td style={{ overflow: 'auto', fontSize: '13px' }}>{this.renderLicenseID(data, idx)}</td>
                            <td style={{ width: '4.7%', fontSize: '13px' }}>{parseInt(data['description'][idx]['subID']) + 1}</td>
                            <td style={{ width: '7.7%', fontSize: '13px' }}>{data['description'][idx]['riceTypeName'] || convertRiceTypeENToTH(data['description'][idx]['riceTypeID'], this.state.riceTypeIDAndName, 'standalone')}</td>
                            <td style={{ width: '7.7%', fontSize: '13px' }}>{addCommaInNumber(this.renderQuantity(data, idx))}</td>
                          </tr>)
                        }
                      }
                    }))
                  }
                }
              })
              }
            </tbody>
          </Table>
        </Container>
      )
    }
    else if (this.state.networkStatus) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading title={this.state.networkStatus} />
      </Container>)
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading title={(() => {
          if (this.state.currentIndex == 0) {
            return null
          } else {
            return `สำเร็จแล้ว ${this.state.currentIndex}/${this.state.finalIndex} รายการ`
          }
        })()} />
      </Container>)
    }
  }
}



export default RequestDaily;
